import { render, staticRenderFns } from "./follow.vue?vue&type=template&id=cdf119d0&scoped=true&"
import script from "./follow.vue?vue&type=script&lang=js&"
export * from "./follow.vue?vue&type=script&lang=js&"
import style0 from "./follow.vue?vue&type=style&index=0&id=cdf119d0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cdf119d0",
  null
  
)

export default component.exports